require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-archive-people-hannah-bennett.json") })
        }
      }, "path---people-archive-people-hannah-bennett");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-archive-people-hannah-bennett!./.cache/json/people-archive-people-hannah-bennett.json
// module id = 1446
// module chunks = 231608221292675